import React, { Component } from "react";
import NavBarHome from "../Components/NavBarHome";
import "./home.css";
import cc from "./VA-CC.png";
import kassidy from "./VA-Kassidy.png";
import capella from "./VA-Capella.png";
import haze from "./VA-Haze.png";
import papa from "./VA-Papa.png";
import genie from "./VA-Genie.png";
import extras from "./VA-Extras.png";

class Voice extends Component {

    render() {
        return (
            <>
                <NavBarHome/>
                <div className="twogrid">
                 <div className="infobox-border">
                        <div className="infobox">
                            <div className="infobox-title">Interested in voicing a character?</div>
                            <p>I get tons of reels from passionate actors looking to work with BLAST CATS, so this page will let you know what I'm looking for!</p>
                            <p>Your talent and dedication to the craft is crucial! Let's make something truly special.</p>
                            <ul>
                                <li>Do you consider yourself a professional?</li>
                                <li>Do you emphasize the acting in voice acting? Are you good with direction?</li>
                                <li>Do you know how to bring your unique flair to a role?</li>
                                <li>Do you hate modern anime dub voice acting?</li>
                                <li>Would I have a beer with you?</li>
                            </ul>
                            <p>Then please send me your reel and socials: <a href="mailto:rob@untilmoraleimproves.studio">rob@untilmoraleimproves.studio</a></p>
                            <p>NOTE: Currently there are no immediate roles available, this page will update when roles are available. You may still send a reel if you are interested in connecting for the future.</p>
                        </div>
                    </div>
                <div className="role-container">
                    <div className="flex-grid">
                        <div className="col">
                            <div class="framed-image-container">
                                <img className = "postIMG" src={cc} alt="C.C. Leo"/>
                                <p class="image-caption">C.C. Leo</p>
                                <p class="role-caption">Voice Actress Role</p>
                                <ul class="char-descript">Her Voice...
                                    <li>In her 20s.</li>
                                    <li>On the lower end, but can rise sharply at times.</li>
                                    <li>A little scratchy.</li>
                                    <li>Tends to shout.</li>
                                    <li>Audio Ref: Aisha Clan Clan (Outlaw Star) Dub or Original Voice</li>
                                </ul>
                                <ul class="char-descript">She Acts...
                                    <li>Short fused, punchy.</li>
                                    <li>Self-conscious about her appearance/behavior.</li>
                                    <li>Easily flustered, overwhelmed. But ultimately powers on.</li>
                                    <li>Rude at times, especially towards pretty women.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <div class="framed-image-container">
                                <img className = "postIMG" src={kassidy} alt="Enchantress Kassidy"/>
                                <p class="image-caption">Kassidy</p>
                                <p class="role-caption">Voice Actress Role</p>
                                <ul class="char-descript">Her Voice...
                                    <li>In her 30s.</li>
                                    <li>Sultry, seductive, liar.</li>
                                    <li>Scary when mad.</li>
                                    <li>Sophisticated pronunciation.</li>
                                    <li>Audio Refs: K.K. Dodds, Rouge the Bat (Sonic), </li>
                                </ul>
                                <ul class="char-descript">She Acts...
                                    <li>Manipulative, devious.</li>
                                    <li>like a snooty princess, looks down on lessers.</li>
                                    <li>Completely unstoppable (in her mind).</li>
                                    <li>Like everyone but her is a moron.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <div class="framed-image-container">
                                <img className = "postIMG" src={capella} alt="Demon Capella"/>
                                <p class="image-caption">Capella</p>
                                <p class="role-caption">Voice Actress Role</p>
                                <ul class="char-descript">Her Voice...
                                    <li>A southern belle mostly.</li>
                                    <li>A commanding demon otherwise.</li>
                                    <li>A little airheaded.</li>
                                </ul>
                                <ul class="char-descript">She Acts...
                                    <li>Compelled by a devil contract, must be nice!</li>
                                    <li>Hates being nice!</li>
                                    <li>Spooky at times.</li>
                                    <li>Very conflicted.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <div class="framed-image-container">
                                <img className = "postIMG" src={haze} alt="Haze"/>
                                <p class="image-caption">Haze</p>
                                <p class="role-caption">Voice Actor Role</p>
                                <ul class="char-descript">His Voice...
                                    <li>Raspy, smoke filled.</li>
                                    <li>Very informal, g-droppin'</li>
                                    <li>Stressed when under duress.</li>
                                    <li>An air of mystery.</li>
                                </ul>
                                <ul class="char-descript">He Acts...
                                    <li>Helpful to a fault.</li>
                                    <li>Empathetic, yet apathetic.</li>
                                    <li>With unknown motives.</li>
                                    <li>Comes from an ancient time, a stranger to the modern world.</li>
                                    <li>But picked up some of it while he boiled in hell.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <div class="framed-image-container">
                                <img className = "postIMG" src={papa} alt="Leo Sr."/>
                                <p class="image-caption">Leo Sr.</p>
                                <p class="role-caption">Voice Actor Role</p>
                                <ul class="char-descript">His Voice...
                                    <li>Deep, Jazzy.</li>
                                    <li>Relaxed, chill.</li>
                                    <li>Commanding in its simplicity.</li>
                                    <li>Playful, butt of the joke.</li>
                                    <li>Easily moved to tears.</li>
                                    <li>Deadly serious when it matters.</li>
                                </ul>
                                <ul class="char-descript">He Acts...
                                    <li>Obsessively a Father.</li>
                                    <li>Weak to the wiles of charming women.</li>
                                    <li>On the hunt for the next opportunity.</li>
                                    <li>Extremely long fuse but highly explosive.</li>
                                    <li>Extremely frugal.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <div class="framed-image-container">
                                <img className = "postIMG" src={genie} alt="The Genie."/>
                                <p class="image-caption">The Genie.</p>
                                <p class="role-caption">Voice Actor Role</p>
                                <ul class="char-descript">His Voice...
                                    <li>Low and Slow.</li>
                                    <li>Uses few words but uses them well.</li>
                                    <li>Mostly monotone and ominous.</li>
                                </ul>
                                <ul class="char-descript">He Acts...
                                    <li>A force of nature, the embodiment of Wishes.</li>
                                    <li>Tunnel visioned on his goal.</li>
                                    <li>Deaf to the suffering of the world.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <div class="framed-image-container">
                                <img className = "postIMG" src={extras} alt="Extras."/>
                                <p class="image-caption">Extras</p>
                                <p class="role-caption">Voice Roles</p>
                                <ul class="char-descript">Extra Voices...
                                    <li>The heart and soul of the world.</li>
                                    <li>Never generic!</li>
                                    <li>Burned into our memories.</li>
                                </ul>
                                <ul class="char-descript">Extras may be...
                                    <li>Simple townsfolk.</li>
                                    <li>Babushkas</li>
                                    <li>City Slickers</li>
                                    <li>Park Rangers</li>
                                    <li>And many more!</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </>
        )
    }
}

export default Voice;